<template>
  <FinishAttendantModal/>
  <UpdateClientModal />
  <div 
    v-if="!isLoadingChatList && getChatList.length == 0"
    class="not-chat-list"
  >
    <!-- Mobile Header with Menu Toggle -->
    <div v-if="isMobile" class="mobile-chat-header d-flex align-items-center justify-content-between p-3 bg-white border-bottom position-fixed w-100" style="top: 0; left: 0; z-index: 50;">
      <button
        type="button"
        class="btn btn-link text-dark p-0"
        @click="toggleMenu"
      >
        <i class="ph ph-list fs-5"></i>
      </button>
      <h6 class="mb-0 fw-bold">Conversas</h6>
    </div>
    <h5 :class="{'mt-5': isMobile}">
      Não existem conversas ativas no momento
    </h5>
    <!-- <div class="text-center mt-15 mt-sm-20 mt-md-25">
      <router-link
        to="/dispatcher"
        class="link-btn text-decoration-none text-primary fw-medium fs-md-15 fs-lg-16 position-relative"
      >
        <i class="ph-bold ph-arrow-left"></i>
        Realizar disparo de mensagens
      </router-link>
    </div> -->

    
  </div>
  <div v-else class="row container-chat">
    <div v-if="!isMobile || !showChat" class="col-lg-4 col-xxxl-3 pe-0 ps-0">
      <!-- Mobile Header with Menu Toggle -->
      <div v-if="isMobile" class="mobile-chat-header d-flex align-items-center justify-content-between p-3 bg-white border-bottom">
        <button
          type="button"
          class="btn btn-link text-dark p-0"
          @click="toggleMenu"
        >
          <i class="ph ph-list fs-5"></i>
        </button>
        <h6 class="mb-0 fw-bold">Conversas</h6>
      </div>
      <div
        class="card border-0 rounded-0 bg-white letter-spacing chat-sidebar column-container-chat"
      >
        <div class="card-body custom-area-chat">
          <form class="search-box position-relative">
            <input
              type="text"
              class="form-control shadow-none text-black rounded-0 border-0"
              placeholder="Pesquise um cliente"
            />
            <button
              type="submit"
              class="bg-transparent text-primary transition p-0 border-0"
            >
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </form>

          <div 
            v-if="isLoadingChatList && getChatList.length > 0" 
            class="overlay-loading"
          >
            <div class="spinner"></div>
          </div>
          
          <div ref="scrollArea" class="chat-users-list" chat-scroll @scroll="onScroll">

            <!-- <div class="single-user-item position-relative">
              <div class="d-flex align-items-center">
                <img
                  src="../../assets/images/user/user1.jpg"
                  width="44"
                  height="44"
                  class="rounded-circle"
                  alt="user"
                />
                <div class="ms-12">
                  <span
                    class="title d-block text-black fs-md-15 fs-lg-16 fw-medium"
                  >
                    Jacob Linowiski
                    <span class="ms-5 text-muted fw-normal fs-12">
                      35 mins ago
                    </span>
                  </span>
                  <span class="d-block text-black">
                    Hey Victor! Could you please...
                  </span>
                </div>
              </div>
              <span
                class="dot-badge text-center d-block fs-12 fw-semibold text-white bg-danger rounded-circle"
              >
                2
              </span>
            </div> -->


            <div v-for="value in getChatList" :key="value.id" @click="onSelectChat(value)" class="single-user-item position-relative" :class="{'current-chat-color': getCurrentChat!= null && getCurrentChat.id == value.id}">
              <div class="d-flex align-items-center">
                <img
                  src="../../assets/images/user/user1.png"
                  width="44"
                  height="44"
                  class="rounded-circle"
                  alt="user"
                />
                <div class="ms-12 chat-list-item-content">
                  <span
                    class="title d-block text-black fs-md-12 fs-lg-12 fw-bold"
                  >
                    {{ value.client.name ? value.client.name : value.client.phone }}
                    <span class="ms-5 text-muted fw-normal fs-10">
                      {{ value.last_message_formatted }}
                    </span>
                  </span>
                  <span v-if="value.last_campaign_id" class="chat-campaign-badge">Campanha · {{ value.last_campaign_name }}</span>
                  <span
                    v-if="value.service_category?.name"
                    class="chat-service-category-badge"
                    :title="value.service_category.name"
                  >{{ value.service_category.name }}</span>
                  <span class="d-block fs-12 text-black limit-2-lines">
                    {{ value.last_message.message }}
                  </span>
                </div>
              </div>
              <!-- <span
                class="dot-badge text-center d-block fs-12 fw-semibold text-white bg-secondary rounded-circle"
              >
                1
              </span> -->
            </div>


          </div>
        </div>
      </div>
    </div>


    <div v-if="!isMobile || showChat" class="col-lg-8 col-xxxl-9 pre-column-chat" :class="{'not-message-chat': getCurrentChat == null}">
      <div 
        v-if="isLoadingMessagesChat && getCurrentChat != null" 
        class="overlay-loading-chat"
      >
        <div class="spinner"></div>
      </div>

      <div v-if="getCurrentChat == null">
        Selecione um chat para interagir com o cliente
      </div>

      
      <div
        v-else
        class="card border-0 rounded-0 bg-white letter-spacing chat-card column-container-chat"
      >
        <div
          class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 title-style"
        >
          <div class="d-flex align-items-center">
            <button
              v-if="isMobile"
              type="button"
              class="btn btn-link text-secondary p-0 me-2"
              @click="onBackToList"
            >
              <i class="ph ph-arrow-left"></i>
            </button>
            <img
              src="../../assets/images/user/user1.png"
              width="44"
              height="44"
              class="rounded-circle chat-header-avatar"
              alt="user"
            />
            <div class="ms-15">
              <span class="d-block text-black fs-md-15 fs-lg-16 fw-medium">{{ getCurrentChat.client.name ? getCurrentChat.client.name : getCurrentChat.client.phone }}</span>
              <span v-if="getCurrentChat.client.name" class="d-block text-success">{{ getCurrentChat.client.phone }}</span>
              <span v-if="getCurrentChat.last_campaign_id" class="chat-campaign-badge">Campanha · {{ getCurrentChat.last_campaign_name }}</span>
              <span v-if="isOfficial" class="d-block fs-10" :class="getCurrentChat.service_window_open ? 'text-success' : 'text-danger'">
                {{ getCurrentChat.service_window_open ? 'Janela de atendimento aberta' : getCurrentChat.campaign_handoff_active ? 'Aguardando resposta do cliente' : 'Janela de 24 horas encerrada' }}
              </span>
            </div>

          </div>
          <div class="d-flex align-items-center gap-2">
            <button
              class="btn btn-outline-primary d-flex align-items-center"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#UpdateClientModal"
              @click="openCurrentClientModal"
              :title="isMobile ? 'Consultar cliente' : ''"
            >
              <i class="flaticon-search-interface-symbol" :class="{ 'me-8': !isMobile }"></i>
              <span v-if="!isMobile">Consultar cliente</span>
            </button>
            <div class="dropdown">
              <button
                class="btn btn-success d-flex align-items-center"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#FinishAttendantModal"
                :title="isMobile ? 'Finalizar atendimento' : ''"
              >
                <i class="flaticon-check" :class="{ 'me-8': !isMobile }"></i>
                <span v-if="!isMobile">Finalizar atendimento</span>
              </button>
            </div>
          </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25 custom-area-chat">

          <div v-for="(value, key) in [getCurrentChat]" :key="key" @scroll="onScrollMessagesChat" class="chat-list">

            <div v-for="(msg, key) in getMessagesChat" :key="key" class="chat-item position-relative" :class="{'right': isOutgoing(msg)}">
              <img
                v-if="!isOutgoing(msg)"
                src="../../assets/images/user/user1.png"
                width="44"
                height="44"
                class="rounded-circle user chat-message-avatar"
                alt="user"
              />

              <div class="message position-relative">
                <div class="inner" :class="{'client-message-color': !isOutgoing(msg)}">
                  <span v-if="msg.campaign_id" class="chat-campaign-badge">Campanha · {{ msg.campaign_name }}</span>
                  <CampaignMedia v-if="msg.campaign_content?.media?.id" :id="msg.campaign_content.media.id" :type="campaignMediaType(msg)" name="Arquivo da campanha" />
                  <p class="fs-13 fs-13 lh-base message-text text-start">
                    {{ msg.message }}
                  </p>
                  <span class="message-date-time fw-bold fs-10 text-muted fw-noarmal ms-15" :class="{'time-style': isOutgoing(msg), 'time-primary-style': !isOutgoing(msg)}">
                    {{ formatMessageTime(msg.date_formatted) }}
                    <span v-if="isOutgoing(msg) && msg.delivery_status" class="ms-1" :title="deliveryLabel(msg.delivery_status)" :aria-label="deliveryLabel(msg.delivery_status)">{{ deliveryIcon(msg.delivery_status) }}</span>
                  </span>
                  <small v-if="isOutgoing(msg) && ['queued', 'processing', 'failed', 'cancelled'].includes(msg.delivery_status)" class="message-delivery-notice" :class="{ 'message-delivery-notice--failed': msg.delivery_status === 'failed' }" role="status">
                    {{ deliveryLabel(msg.delivery_status) }}
                    <span v-if="msg.error_message" class="message-delivery-error">{{ msg.error_message }}</span>
                  </small>
                  <small v-if="msg.source === 'business_app'" class="d-block mt-1 message-source">
                    Enviada pelo WhatsApp Business no celular
                  </small>
                </div>
              </div>
            </div>






            <!-- <div class="chat-item position-relative right">
              <span class="fs-12 text-muted fw-noarmal d-block mb-10"
                >12th Mar</span
              >
              <div class="message position-relative">
                <div class="inner">
                  <p class="fs-md-15 fs-lg-16 lh-base">
                    Oh Sure! Here’s the transaction number: 32x43l56uvtrc5T
                  </p>
                </div>
              </div>
            </div> -->





          </div>
          <div v-if="templateMode" class="template-picker mb-2">
            <div class="alert alert-warning py-2 mb-2">{{ getCurrentChat.campaign_handoff_active ? 'Aguardando resposta. A janela de mensagens livres abre quando o cliente responder.' : 'A janela de 24 horas está encerrada. Use um template aprovado para retomar o contato.' }}</div>
            <div class="d-flex gap-2 flex-wrap">
              <select v-model="selectedTemplateId" class="form-select flex-grow-1"><option value="">Selecione um template</option><option v-for="item in getWhatsappTemplates" :key="item.id" :value="item.id">{{ item.name }} — {{ item.category }}</option></select>
              <input v-model="templateParametersText" class="form-control flex-grow-1" placeholder="Parâmetros separados por |">
              <button type="button" class="btn btn-primary" :disabled="!selectedTemplateId || sendingTemplate" @click="submitTemplate">Enviar template</button>
            </div>
          </div>
          <form v-else ref="inputSendMessage" @submit.prevent="submitMessageChat">
            <div class="write-your-message position-relative">
              <div class="write-message position-relative custom-area-write">
                <input
                  ref="inputMessage"
                  type="text"
                  class="input-message d-block w-100 text-black fs-14"
                  placeholder="Escreva sua mensagem..."
                />
              </div>
              <div class="d-flex buttons-list custom-style-button-send-message">
                <button
                  type="submit"
                  class="border-0 d-inline-block position-relative text-center transition active"
                  @pointerdown.prevent
                >
                  <i class="flaticon-airplane"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import FinishAttendantModal from './FinishAttendantModal';
import UpdateClientModal from '../Clients/UpdateClientModal.vue';
import stateStore from '../../utils/store';
import CampaignMedia from '../Campaigns/CampaignMedia.vue';
import api from '../../config/axios';

export default {
  name: "ChatContent",
  components:{
    CampaignMedia,
    FinishAttendantModal,
    UpdateClientModal,
  },
  data() {
    return {
      isMobile: false,
      showChat: false,
      syncInterval: null,
      templateMode: false,
      selectedTemplateId: '',
      templateParametersText: '',
      sendingTemplate: false,
    };
  },
  methods: {
    campaignMediaType(message) { return message.campaign_content?.components?.find(c => c.type === 'HEADER')?.format?.toLowerCase() || 'document'; },
    ...mapActions([
      'fetchChatList',
      'fetchMessagesChat',
      'setCurrentChat',
      'sendMessageChat',
      'sendTemplateMessageChat',
      'fetchChatWhatsappTemplates',
      'syncChatList',
      'setCurrentUpdateClient',
      'setCurrentUpdateClientTab'
    ]),
    openCurrentClientModal() {
      if (!this.getCurrentChat || !this.getCurrentChat.client) {
        return;
      }

      this.setCurrentUpdateClientTab('appointments');
      this.setCurrentUpdateClient(this.getCurrentChat.client);
    },
    onSelectChat(chat) {
      this.setCurrentChat(chat);
      if (this.isMobile) {
        this.showChat = true;
      }
    },
    onBackToList() {
      this.showChat = false;
      // Keep current chat selected but hide it; optional: clear current chat
      // this.setCurrentChat(null);
    },
    updateMobileChatOpenClass() {
      window.dispatchEvent(new CustomEvent("mobile-chat-open-change", {
        detail: {
          open: this.isMobile && this.showChat,
        },
      }));
    },
    toggleMenu() {
      stateStore.onChange();
    },
    async submitMessageChat(){


      const inputMessage = this.$refs.inputMessage;
      if(inputMessage.value.trim() == "" || this.getCurrentChat == null){
        this.focusMessageInput();
        return;
      }

      const params = {
        "message": inputMessage.value,
        "chat_id": this.getCurrentChat.id
      }

      try {
        await this.sendMessageChat(params);
        inputMessage.value = "";
        this.focusMessageInput();
      } catch (error) {
        if(error.response?.status === 409 && error.response?.data?.code === 'WHATSAPP_WINDOW_CLOSED'){
          this.templateMode = true;
          if(this.templateMode) await this.fetchChatWhatsappTemplates().catch(error => console.warn('Não foi possível carregar templates', error));
        }
      }

    },
    async submitTemplate(){
      if(!this.selectedTemplateId || !this.getCurrentChat) return;
      this.sendingTemplate = true;
      try {
        await this.sendTemplateMessageChat({
          chat_id: this.getCurrentChat.id,
          template_id: this.selectedTemplateId,
          parameters: this.templateParametersText ? this.templateParametersText.split('|').map(value => value.trim()) : []
        });
        this.selectedTemplateId = '';
        this.templateParametersText = '';
      } finally {
        this.sendingTemplate = false;
      }
    },
    isOutgoing(message){
      return message.direction ? message.direction === 'outbound' : message.sent_by == this.getConfigurations.whatsapp_number;
    },
    deliveryIcon(status){
      return ({ queued: '○', processing: '○', accepted: '✓', sent: '✓', delivered: '✓✓', read: '✓✓', failed: '!', cancelled: '×' })[status] || '';
    },
    deliveryLabel(status){
      return ({ queued: 'Aguardando envio ao WhatsApp', processing: 'Envio em processamento', accepted: 'Aceita pela Meta para envio', sent: 'Enviada ao WhatsApp', delivered: 'Entregue', read: 'Lida', failed: 'Não enviada', cancelled: 'Envio cancelado' })[status] || '';
    },
    focusMessageInput() {
      this.$nextTick(() => {
        const inputMessage = this.$refs.inputMessage;
        if (!inputMessage) {
          return;
        }

        if (typeof inputMessage.focus === "function") {
          inputMessage.focus({ preventScroll: true });
        }
      });
    },
    formatMessageTime(dateFormatted) {
      if (!dateFormatted) {
        return "";
      }

      const [time] = String(dateFormatted).split(" ");
      const [hour, minute] = time.split(":");

      return hour && minute ? `${hour}:${minute}` : time;
    },
    onScroll(e) {
      if(this.isLoadingChatList || this.getNextPageUrl == null){
        return;
      }

      const el = e.target;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 50) {
            this.fetchChatList(this.getNextPageUrl)
        }
    },
    onScrollMessagesChat(e) {
      if(this.isLoadingMessagesChat || this.getNextPageUrlMessagesChat == null){
        return;
      }

      const el = e.target;

        if (Math.abs(el.scrollTop) + el.clientHeight >= el.scrollHeight - 50) {

          this.fetchMessagesChat(this.getNextPageUrlMessagesChat.replace("chatId", this.getCurrentChat.id))
        }
    },
  },
  watch: {
    getCurrentChat(newValue){
      if(newValue){
        this.fetchMessagesChat(`/api/chat/${newValue.id}/messages`);
        this.templateMode = this.isOfficial && !newValue.service_window_open;
        if(this.templateMode) this.fetchChatWhatsappTemplates().catch(error => console.warn('Não foi possível carregar templates', error));
        if (this.isMobile) {
          this.showChat = true;
        }
      }
    },
    showChat() {
      this.updateMobileChatOpenClass();
    },
    isMobile(newValue) {
      if (!newValue) {
        this.showChat = false;
      }
      this.updateMobileChatOpenClass();
    },
    getConfigurations(newValue){
      console.log("watch getConfigurations", newValue);
    }
  },
  computed: {
    ...mapGetters([
      'getFirstLoading',
      'getChatList',
      'getNextPageUrl',
      'isLoadingChatList',
      'getCurrentChat',
      'isLoadingSetCurrentChat',
      'isLoadingMessagesChat',
      'getNextPageUrlMessagesChat',
      'getMessagesChat',
      'getConfigurations',
      'getWhatsappTemplates'
    ]),
    isOfficial(){
      return this.getConfigurations?.whatsapp_provider === 'cloud_api';
    },
    isCoexistence(){
      return this.isOfficial && this.getConfigurations?.whatsapp_cloud_mode === 'coexistence';
    },
    coexistenceWindowClosed(){
      return this.isCoexistence && this.getCurrentChat && !this.getCurrentChat.service_window_open;
    }
  },







  async mounted() {
    // Handle responsive mobile behavior
    this._setMobile = () => {
      const isMobile = window.innerWidth <= 767;
      this.isMobile = isMobile;
      if (!isMobile) {
        this.showChat = false;
      }
    };

    this._setMobile();
    window.addEventListener('resize', this._setMobile);
    this.updateMobileChatOpenClass();

    await this.fetchChatList(this.getNextPageUrl);
    const requestedChat = Number(this.$route.query.chat);
    if (requestedChat) {
      try { const response = await api.axios.get('/api/chat/'+requestedChat); const chat = response.data?.data?.[0]; if (chat) { this.$store.commit('setChatList', [chat]); this.onSelectChat(chat); } } catch (error) { console.warn('Não foi possível abrir a conversa solicitada.'); }
    }

    // Iniciar sincronização a cada 5 minutos (300000 ms)
    this.syncInterval = setInterval(() => {
      this.syncChatList();
    }, 300000);

  },
  unmounted() {
    this.setCurrentChat(null);
    window.dispatchEvent(new CustomEvent("mobile-chat-open-change", {
      detail: {
        open: false,
      },
    }));
    if (this._setMobile) {
      window.removeEventListener('resize', this._setMobile);
    }
    if (this.syncInterval) {
      clearInterval(this.syncInterval);
    }
  }









};
</script>

<style scoped>
.chat-list-item-content { min-width: 0; flex: 1; }
.chat-service-category-badge {
  display: block;
  width: fit-content;
  max-width: 100%;
  margin: 3px 0;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.4;
  color: #28695d;
  background: #e7f4ef;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:global(body.dark .chat-service-category-badge) { color: #a7e4d3; background: #24483f; }
.chat-campaign-badge{display:block;width:fit-content;max-width:100%;font-size:10px;line-height:1.5;color:#6554c0;background:#eee9ff;border-radius:5px;padding:3px 7px;margin:4px 0;overflow-wrap:anywhere}


.not-chat-list{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.container-chat{
  /* height: calc(100vh - 90px); */
  /* background-color: #fff; */
}

.column-container-chat{
  height: 100vh !important;
}

.pre-column-chat{
  padding-left: unset !important;
  height: 100vh !important;
}

.custom-area-chat{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: unset !important;
  padding-left: 18px !important;
}

.search-box{
  height: 5% !important;
  padding-left: 12px;
}

.chat-users-list{
  height: calc(100vh - 90.55px) !important;
  margin-top: 0px !important;
}

.custom-chat-page-style{
  padding-left: 275px !important;
  padding-right: unset !important;
  padding-top: unset !important;
}

.time-primary-style{
  color: #000;
}

.time-style{
  color: #bdc3c7 !important;
}

.title-style{
  border-radius: 12px;
}

.write-your-message{
  margin-bottom: 25px !important;
  margin-top: unset !important;

  padding-right: unset !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.custom-style-button-send-message{
  top: unset !important;
  right: unset !important;
  position: unset !important;
  transform: unset !important;
}

.custom-area-write{
  width: 100%;
  padding: 16px 20px 16px 10px !important;
}

.custom-area-write .input-message {
  border-left: unset !important;
}

.chat-list{
  height: calc(100vh - 200px) !important;
  display: flex;
  flex-direction: column-reverse; /* INVERTE A LISTA */
  overflow-y: auto;
}

.not-message-chat{
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #fff; */
}

.chat-list-wrapper {
    position: relative;
}

.overlay-loading {
    position: absolute;
    inset: 0; /* cobre toda a div */
    backdrop-filter: blur(2px); /* opcional */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    pointer-events: auto; /* BLOQUEIA todos os cliques */
}

.inner{
  padding: 12px 17px !important;
}

.spinner {
    width: 32px;
    height: 32px;
    border: 3px solid #ccc;
    border-top-color: #2c7be5;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    from { transform: rotate(0); }
    to   { transform: rotate(360deg); }
}

/* .overlay-loading-chat{
  width: 100%;
  position: relative;
  height: 100%;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  pointer-events: auto;
} */

.overlay-loading-chat {
    width: calc(100% - calc(280px + 20%));
    position: absolute;
    right: 0px !important;
    height: 100%;
    /* background: rgba(0, 0, 0, 0.2); */
    backdrop-filter: blur(2px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    pointer-events: auto;
}

.limit-2-lines{
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.current-chat-color{
  background-color: #00b894 !important;

  border-radius: 10px !important;
  border-bottom: unset !important;
  /* box-shadow: 0px 5px 17px -5px #000 !important; */
}
.current-chat-color span{
  color: #fff !important;
}

.current-chat-color:hover{
  background-color: #00b894 !important;
}
.current-chat-color:before{
  background-color: #00b894 !important;
}
.current-chat-color:focus-visible{
  background-color: #00b894 !important;
}

.single-user-item:hover{
  background-color: #81ecec;
}

.chat-sidebar .card-body .chat-users-list .single-user-item::before{
  transition: none !important;
  background-color: #81ecec;
  color: #fff !important;
}

.dark .single-user-item:hover{
  background-color: var(--splash-black-color) !important;
}

.dark .chat-sidebar .card-body .chat-users-list .single-user-item::before{
  background-color: var(--splash-black-color) !important;
}

.client-message-color{
  background-color: #00b894 !important;
  color: #fff;
}

.client-message-color p, .client-message-color span{
  color: #fff !important;
}

.message-text {
  white-space: pre-line;
  word-break: break-word;
}

.message-date-time {
  width: fit-content;
  line-height: 1.25;
  margin-top: 8px;
  margin-left: auto !important;
}

.message-source {
  color: #64748b;
  font-size: 10px;
}

.message-delivery-notice {
  display: block;
  clear: both;
  margin-top: 8px;
  padding: 6px 8px;
  border: 1px solid rgba(255, 255, 255, .4);
  border-radius: 5px;
  background: rgba(255, 255, 255, .12);
  color: inherit;
  font-size: 11px;
  line-height: 1.4;
}
.message-delivery-notice--failed { color: #9f1239; background: #fff1f2; border-color: #fecdd3; }
.message-delivery-error { display: block; margin-top: 3px; overflow-wrap: anywhere; }

@media (max-width: 767px) {
  /* Ensure chat stacks cleanly on small screens without fixed viewport heights */
  .not-chat-list {
    padding: 0 18px;
  }

  .not-chat-list h5 {
    margin-top: 0 !important;
  }

  .mobile-chat-header {
    display: none !important;
  }

  .container-chat {
    height: 100% !important;
    min-height: 0;
    overflow: hidden;
    width: 100% !important;
  }

  .search-box {
    height: auto !important;
  }

  .column-container-chat,
  .pre-column-chat {
    height: 100% !important;
    min-height: 0;
  }

  .column-container-chat{
    padding: 0 10px 10px !important;
  }

  .row,
  .container-chat, 
  .pre-column-chat{
    padding-right: unset !important;
    padding-left: unset !important;
    margin-left: unset !important;
  }

  .custom-area-chat {
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
    padding-left: 0 !important;
    padding-right: 0 !important;
    justify-content: flex-start !important;
  }

  .btn-success{
    font-size: 9pt;
    padding: 10px;
  }

  .title-style .btn {
    width: 42px;
    height: 42px;
    min-width: 42px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }

  .title-style .btn i {
    margin-right: 0 !important;
  }

  .title-style .btn-link {
    text-decoration: none !important;
  }

  .chat-card {
    display: flex;
    flex-direction: column;
    margin-left: -10px;
    margin-right: -10px;
    width: calc(100% + 20px);
  }

  .chat-card .card-head {
    flex: 0 0 auto;
  }

  .chat-card .title-style {
    border-radius: 0;
  }

  .chat-header-avatar,
  .chat-message-avatar {
    display: none !important;
  }

  .chat-users-list {
    flex: 1 1 auto;
    min-height: 0;
    height: auto !important;
    max-height: none !important;
    overflow-y: auto;
  }

  .chat-list {
    flex: 1 1 auto;
    min-height: 0;
    height: auto !important;
    max-height: none !important;
    overflow-y: auto;
    overscroll-behavior: contain;
    padding-left: 12px;
    padding-right: 10px;
  }

  .chat-list .chat-item {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    max-width: 100% !important;
    padding-left: 0 !important;
  }

  .chat-list .chat-item.right {
    justify-content: flex-end;
    margin-left: 0;
    margin-right: 0;
    max-width: 100% !important;
    text-align: right;
  }

  .chat-list .chat-item .message,
  .chat-list .chat-item.right .message {
    width: auto;
    max-width: 82%;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .chat-list .chat-item .message .inner {
    max-width: 100%;
  }

  .overlay-loading-chat {
    width: 100% !important;
    left: 0 !important;
    right: 0 !important;
  }

  .write-your-message {
    display: flex !important;
    flex: 0 0 auto;
    gap: 8px;
    align-items: center !important;
    padding: 8px 10px 0px !important;
    margin-bottom: 0 !important;
  }

  .custom-area-write {
    height: 48px;
    min-height: 48px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    align-self: center;
    border-radius: 8px;
    padding: 12px 16px !important;
  }

  .custom-area-write .input-message {
    font-size: 16px !important;
  }

  .custom-style-button-send-message button {
    top: auto !important;
    width: 48px !important;
    height: 48px !important;
    min-width: 48px !important;
    min-height: 48px !important;
    box-sizing: border-box;
    display: inline-flex;
    padding: 0 !important;
    position: relative !important;
    align-items: center;
    justify-content: center;
    line-height: 1 !important;
    margin-top: 0 !important;
    margin-right: 0 !important;
    transform: none !important;
    border-radius: 8px !important;
  }

  .custom-style-button-send-message {
    height: 48px !important;
    display: flex !important;
    align-items: center !important;
    align-self: center;
  }

  .chat-users-list {
    max-height: none !important;
  }
}

</style>
